// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NBkvx7TzTAZ4ZXLznv9i"};